export default __webpack_public_path__ + "static/media/cf.a9e3f63c.svg";